<div class="login-register" style="background-image: url(assets/images/background/download.jpg)">
  <div class="login-register-box">
    <mat-card>
      <mat-card-content fxLayoutGap="30px" fxLayoutAlign="center center" fxLayout="column" style="padding: 50px;">
        <div fxLayoutAlign="center center">
          <img src="assets/images/logo-light-text.svg" alt="Situ Logo" fxFlex="100">
        </div>
        <h4>Signing you in...</h4>
      </mat-card-content>
    </mat-card>
  </div>
</div>
